import { render, staticRenderFns } from "./ListeDesCommandes.vue?vue&type=template&id=4272a0a3&"
import script from "./ListeDesCommandes.vue?vue&type=script&lang=js&"
export * from "./ListeDesCommandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports